var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ed-dropdown',{attrs:{"selected":_vm.getRouteName(_vm.currentRoute),"listItems":_vm.createDropdownList,"isSelected":_vm.onChange,"styles":"min-width: 10rem","customClass":"ed-dropdown__sm"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }